module.exports = __webpack_public_path__ + "static/img/gowling.caca64d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/home-page-logos/gowling.png
// module id = Ip+q
// module chunks = 0